<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能厨房秤</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 70%;" class="oneBodyImgCls" src="../assets/images/cc3623_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能厨房秤</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          厨房秤是一个智能称重设备，主要有称重、扫描二维码、刷卡和RFID感应（需定制）等功能，通过这些功能让作业人员快速进行称重工作并让数据得到保存，方便后台进行查看，提高经济效率和管 理效率。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">
        553.5mm(长)*420mm(宽)*1465mm(高)
      </div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/cc3623_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">一</div>
        <div class="three_body_left_right">高清大屏触摸交互：10.1寸高清显示屏，电容触摸，交互体验；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">二</div>
        <div class="three_body_right_right">多接口网络连接：WiFi/3G/4G或有线网络，方便不同网络环境实施，并可支持后台远程更新升级；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">三</div>
        <div class="three_body_left_right">语音播报：为刷卡提供立体声语音提示及语音播放，减少漏刷或刷卡不成功概率；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">四</div>
        <div class="three_body_right_right">支持二维码扫码：通过扫描器扫码居民积分卡二维码，使居民身份证识别操作更便捷；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">五</div>
        <div class="three_body_left_right">高清广角摄像头（需要定制）：可通过拍照称重物品，通过后台进行类别判定；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">六</div>
        <div class="three_body_right_right" style="text-align: right">远程维护：服务器可进行远程升级和维护。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="margin-top: 24px" src="../assets/images/cc3623_center_003.png"/>
      <div class="center_four_text">(可定制)</div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })
  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 517px;

    .oneBodyImgCls {
      width: 100%;
      height: 517px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 590px;

    .oneBodyImgCls {
      width: 100%;
      height: 590px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 776px;

    .oneBodyImgCls {
      width: 100%;
      height: 776px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}

</style>